module.exports = __webpack_public_path__ + "img/hjzr.115b207b.jpg";